
import { DataWithPagination } from "services/api/types";
import { Pagination } from "services/search";

import { createApiCall, paginatedApiCall } from "services/api/createApiCall";

import { transformErrorResponse } from "services/api/transformation";
import { transformTranslation, transformTranslationCreate, transformTranslationOnUpdate, transformTranslationRow } from "./transformation";
import { Translation, TranslationCreateFormValues, TranslationEditFormValues, TranslationRow } from "./types";


/*---------------------------------------------------------------------------------------
    SETTING TRANSLATION - SEARCH
-----------------------------------------------------------------------------------------*/


export const getTranslationsAPI = async (
  pagination: Pagination,
  languageId: string,
  name?: string | null
): Promise<DataWithPagination<TranslationRow>> => {
  let path = `/v1/translations?translationLanguageId=${languageId}&name=`;

  if (name) path += `${name}`;
  return await paginatedApiCall(path, pagination, transformTranslationRow);
};

/*---------------------------------------------------------------------------------------
      SETTING TRANSLATION -GET BY ID
-----------------------------------------------------------------------------------------*/
export const getTranslationAPI = async (id: string): Promise<Translation> => {
  const response = await createApiCall(
    {
      path: `/v1/translations/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformTranslation(response.data);
};

/*---------------------------------------------------------------------------------------
      SETTING TRANSLATION - CREATE
-----------------------------------------------------------------------------------------*/
export const createTranslationAPI = async (
  formValues: TranslationCreateFormValues
): Promise<Translation> => {
  const response = await createApiCall(
    {
      path: "/v1/admin/translations",
      method: "POST",
      body: transformTranslationCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Prijevod je uspješno kreirana",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformTranslation(response.data);
};

/*---------------------------------------------------------------------------------------
      SETTING TRANSLATION -UPDATE
-----------------------------------------------------------------------------------------*/
export const updateTranslationAPI = async (
  id: string,
  formValues: TranslationEditFormValues
): Promise<Translation> => {
  const response = await createApiCall(
    {
      path: `/v1/admin/translations/${id}`,
      method: "PUT",
      body: transformTranslationOnUpdate(formValues),
    },
    {
      getMessage: {
        success: () => "Prijevod je uspješno ažuriran",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformTranslation(response.data);
};



